import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StylesheetsService } from '../../../services/stylesheets/stylesheets.service';
import { NotyService } from '../../../services/common/noty.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stylesheets-index',
  templateUrl: './stylesheets-index.component.html',
  styleUrls: ['./stylesheets-index.component.scss'],
})
export class StylesheetsIndexComponent implements OnInit, OnDestroy {
  constructor(private stylesheetsService: StylesheetsService, private notyService: NotyService, private router: Router, private route: ActivatedRoute) {}
  searchTerm: String = '';
  stylesheets: Array<any> = [];
  componentDestroyed: boolean = false;
  paginateParams: any = {
    page: 1,
    per_page: 5,
  };
  stylesheetsMaxCount: number;

  ngOnInit(): void {
    this.stylesheetsService
      .searchOptions({ angular: true, search_options: true })
      .then((success) => {
        if(this.componentDestroyed) return;
        this.paginateParams.per_page = success.per_page;
        console.log('searchOptions success', success);
        this.loadStylesheets();
      })
      .catch((error) => {
        if(this.componentDestroyed) return;
        console.log(error);
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed = true;
  }

  shortenStylesheetContent(content: any) {
    if (content && content.length > 30) {
      content = content.slice(0, 30) + '...';
      return content;
    } else {
      return content || 'Nil';
    }
  }

  loadStylesheets(pageEvent: any = null) {
    if(this.componentDestroyed) return Promise.resolve();
    if (pageEvent) this.paginateParams.page = pageEvent.page;
    let { page, per_page } = this.paginateParams;
    return this.stylesheetsService
      .index({ page, per_page })
      .then((stylesheetsIndexRe) => {
        if(this.componentDestroyed) return;
        console.log('stylesheetsIndexRe', stylesheetsIndexRe);
        stylesheetsIndexRe.stylesheets.forEach((stylesheet: any) => {
          stylesheet.isDeleting = false;
        });
        this.stylesheets = stylesheetsIndexRe.stylesheets;
        this.stylesheetsMaxCount = stylesheetsIndexRe.totalCount;
      })
      .catch((stylesheetsIndexErr) => {
        if(this.componentDestroyed) return;
        console.log('stylesheetsIndexErr', stylesheetsIndexErr);
      });
  };

  searchStylesheets() {
    if(this.componentDestroyed) return Promise.resolve();
    return this.stylesheetsService
      .index({ name: this.searchTerm })
      .then((searchStylesheetsRe) => {
        if(this.componentDestroyed) return;
        this.stylesheets = searchStylesheetsRe.stylesheets;
        this.stylesheetsMaxCount = searchStylesheetsRe.totalCount;
      })
      .catch((searchError) => {
        if(this.componentDestroyed) return;
        console.log('searchError', searchError);
      });
  };

  deleteStyleSheet(id: number, stylesheet: any) {
    if(this.componentDestroyed) return Promise.resolve();
    stylesheet.isDeleting = true;
    return this.stylesheetsService
      .delete({ id })
      .then((styleSheetDeleteRe) => {
        if(this.componentDestroyed) return;
        console.log('stylesheet deleted', styleSheetDeleteRe);
        this.notyService.notify('Stylesheet Deleted', 'success');
        stylesheet.isDeleting = false;
        this.loadStylesheets();
      })
      .catch((err) => {
        if(this.componentDestroyed) return;
        console.log(err);
      });
  };
}
